import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import api from '../api/axios';
import { useAuth } from './AuthContext';

// Personal colours of all users (id → hex), loaded once after sign-in.
// Every place that shows a person can look the colour up by user id.

const FALLBACK = '#94A3B8';
const UserColorsContext = createContext({ colorOf: () => FALLBACK, refreshColors: () => {} });

export function UserColorsProvider({ children }) {
  const { user } = useAuth();
  const [colors, setColors] = useState({});

  const refreshColors = useCallback(() => {
    api.get('/users/colors')
      .then((res) => setColors(res.data?.colors || {}))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (user?.id) refreshColors();
    else setColors({});
  }, [user?.id, user?.color, refreshColors]);

  const colorOf = useCallback((userId) => (userId != null && colors[userId]) || FALLBACK, [colors]);

  return (
    <UserColorsContext.Provider value={{ colorOf, refreshColors, colors }}>
      {children}
    </UserColorsContext.Provider>
  );
}

export function useUserColors() {
  return useContext(UserColorsContext);
}
